import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { BuildInfoService } from '../../../core/services/build-info.service';
import { APP_BRAND } from '../../../core/branding/brand.config';

@Component({
  selector: 'app-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  private readonly buildInfoService = inject(BuildInfoService);
  private readonly deployDateFormatter = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
    year: 'numeric',
  });
  protected readonly brand = APP_BRAND;

  protected readonly buildInfo = toSignal(this.buildInfoService.getBuildInfo(), {
    initialValue: null,
  });

  protected environmentLabel(environment: string): string {
    const normalized = environment.trim().toLowerCase();

    if (normalized === 'uat') {
      return 'UAT';
    }

    if (normalized === 'dev') {
      return 'Dev';
    }

    return normalized ? normalized.toUpperCase() : 'Build';
  }

  protected deployedDate(deployedAt: string): string {
    const date = new Date(deployedAt);

    if (Number.isNaN(date.getTime())) {
      return deployedAt;
    }

    return this.deployDateFormatter.format(date);
  }
}
